import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "./BuyCrypto.css";

const BuyCrypto = () => {
  // const [activeTab, setActiveTab] = useState("Overview");

  const location = useLocation();
  const outletRef = useRef(null);
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState();

  
     useEffect(() => {
      document.title = "Buy Crypto | TillionX";
    }, []);

  useEffect(() => {
    if (outletRef.current) {
      outletRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        
      });
    }
  }, [location]);

  const services = [
    { label: "BuyAndSell", route: "BuyAndSell" },
    { label: "Limit Buy", route: "Limitbuy" },
    { label: "Recurring Buy", route: "RecurringBuy" },
    // { label: "Deposit", route: "Deposit" },
    // { label: "Withdraw", route: "Withdraw" },
  ];

  const handleCardClick = (e, route) => {
    e.preventDefault();
    setSelectedCard(route);
    navigate(`/buycrypto/${route}`);
  };
useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>

      <div className="buy-crypto-page">
        <Header />

        <div className="buy-crypto-content">
          <div className="buy-crypto-tabs">
           
            {services.map((service, index) => (
              <div
                key={index}
                onClick={(e) => handleCardClick(e, service.route)}
                className={selectedCard === service.route ? "active" : ""}
              >
                {service.label}
              </div>
            ))}
          </div>

          <div ref={outletRef}>
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default BuyCrypto;
